import React from 'react'
import LtsInputText from '../../../../components/lottus/lts-input-text'
import _ from 'lodash'
import { Button } from 'primereact/button'
import { icons } from '../../../../constants'

export const PbAtendimentoForm = (props) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card card-w-title">
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'nomeResponsavel', '')}
                  label={'Nome Completo'}
                  onChange={(e) => props.setField('nomeResponsavel', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'nomeFalecido', '')}
                  label={'Nome Falecido'}
                  onChange={(e) => props.setField('nomeFalecido', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <LtsInputText
                  value={_.get(props.record, 'foneResponsavel', '')}
                  label={'Fone Contato'}
                  onChange={(e) => props.setField('foneResponsavel', e)}
                />
              </div>
            </div>
            <div className="p-grid form-group">
              <div className="p-col-12">
                <Button
                  label={'Solicitar Atendimento'}
                  onClick={() => {
                    props.onClickSolicitarAtendimento()
                  }}
                  disabled={!props.canSolicitarAtendimento()}
                  icon={icons.CHECK_ICON}
                  className="p-button-success"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
